<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="onCancel()" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" class="cursor-move pr-12">
		{{ t('tenantunitDetails.dateRangeFilter.title') }}
	</h2>
	<mat-dialog-content>
		<form [formGroup]="dateForm" class="pt-4">
			<div class="flex flex-col w-full">
				<div class="grid grid-cols-2 gap-4 pt-4">
					<div class="flex flex-col">
						<div class="flex flex-row justify-between items-start mx-2 pt-2">
							<button class="quick-date-btn pr-1" (click)="validFrom.setValue(validFrom.value.subtract(1, 'year'))">
								-1 {{ t('enum.YEAR') }}
							</button>
							<button class="quick-date-btn pr-1" (click)="validFrom.setValue(dayjs())">{{ t('common.today') }}</button>
							<button class="quick-date-btn pr-1" (click)="validFrom.setValue(validFrom.value.endOf(YEARS))">
								{{ t('common.endOfYear') + dayjs().format("'YY") }}
							</button>
							<button class="quick-date-btn" (click)="validFrom.setValue(validFrom.value.add(1, 'year'))">+1 {{ t('enum.YEAR') }}</button>
						</div>
						<mat-form-field appearance="outline">
							<mat-label>{{ t('tenantunitDetails.details.validFrom') }}</mat-label>
							<input matInput [matDatepicker]="pickerFrom" formControlName="validFrom" />
							<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
							<mat-datepicker #pickerFrom></mat-datepicker>
							@if (validFrom?.hasError('required')) {
								<mat-error>{{ t('common.requiredField') }}</mat-error>
							}
						</mat-form-field>
					</div>
					<div class="flex flex-col">
						<div class="flex flex-row justify-between items-start mx-2 pt-2">
							<button class="quick-date-btn pr-1" (click)="validTo.setValue(validTo.value.subtract(1, 'year'))">-1 {{ t('enum.YEAR') }}</button>
							<button class="quick-date-btn pr-1" (click)="validTo.setValue(dayjs())">{{ t('common.today') }}</button>
							<button class="quick-date-btn pr-1" (click)="validTo.setValue(dayjs().endOf(YEARS))">
								{{ t('common.endOfYear') + dayjs().format("'YY") }}
							</button>
							<button class="quick-date-btn" (click)="validTo.setValue(validTo.value.add(1, 'year'))">+1 {{ t('enum.YEAR') }}</button>
						</div>
						<mat-form-field appearance="outline">
							<mat-label>{{ t('tenantunitDetails.details.validTo') }}</mat-label>
							<input matInput [matDatepicker]="pickerTo" formControlName="validTo" />
							<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
							<mat-datepicker #pickerTo></mat-datepicker>
							@if (validTo?.hasError('required')) {
								<mat-error>{{ t('common.requiredField') }}</mat-error>
							}
						</mat-form-field>
					</div>
				</div>
				@if (dateForm.hasError('dateRangeInvalid')) {
					<mat-error>
						{{ t('errors.dateOrder') }}
					</mat-error>
				}
			</div>
		</form>
		<div class="flex items-center justify-start w-full pt-4">
			<div class="text-black pr-4 whitespace-nowrap flex-shrink-0 font-bold">
				{{ t('billing.dateRangeTemplates') }}
			</div>
			<hr class="w-full my-4" />
		</div>

		<form [formGroup]="billingDateForm" class="pt-4">
			<div class="grid grid-cols-2 gap-4 pt-4">
				<mat-form-field appearance="outline">
					<mat-label>{{ t('billing.billing') }}</mat-label>
					<mat-select (selectionChange)="loadPeriods($event.value)" formControlName="billing">
						@for (billing of billings(); track billing.exportId) {
							<mat-option [value]="billing">{{ billing.billingNumber }}: {{ billing.billingName }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<div class="flex flex-row items-center gap-2">
					<mat-form-field appearance="outline" class="flex-1">
						<mat-label>{{ t('billing.periods') }}</mat-label>
						<mat-select formControlName="billingPeriod">
							@for (period of periods(); track period.exportId) {
								<mat-option [value]="period">
									{{ dateUtil.setDateFormatByActiveLang(period.validFrom, '') }} -
									{{ dateUtil.setDateFormatByActiveLang(period.validTo, '') }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<button
						(click)="copyPeriodDate()"
						[disabled]="!getPeriodDate().value"
						[matTooltip]="t('billing.templateToDateRange')"
						mat-icon-button
						color="primary">
						<mat-icon fontSet="material-symbols-outlined">event_upcoming</mat-icon>
					</button>
				</div>
			</div>
		</form>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-raised-button color="primary" (click)="onSave()" [disabled]="!this.dateForm.valid">{{ t('common.apply') }}</button>
	</mat-dialog-actions>
</div>
